import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasApprovedAndPending: null,
};

const listingStatusSlice = createSlice({
  name: "listingStatus",
  initialState,
  reducers: {
    checkApprovedAndPending: (state, action) => {
      const groupedStatus = action.payload;
      state.hasApprovedAndPending =
        !!groupedStatus.APPROVED?.length && !!groupedStatus.PENDING?.length;
    },
    resetListingStatus: (state) => {
      state.hasApprovedAndPending = null;
    },
  },
});

export const { checkApprovedAndPending, resetListingStatus } =
  listingStatusSlice.actions;
export default listingStatusSlice.reducer;
